module.exports = __webpack_public_path__ + "static/img/票@2x.166a622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/票@2x.png
// module id = 9VnB
// module chunks = 192